import styled from 'styled-components';

import { Text } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const Container = styled.div<{ $positiveDeltaColor?: 'green' | 'red'; $deltaValue?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 12px;

  background-color: ${(props) => {
    if (!props.$deltaValue || !props.$positiveDeltaColor) {
      return 'none';
    }

    if (
      (props.$deltaValue > 0 && props.$positiveDeltaColor === 'green') ||
      (props.$deltaValue < 0 && props.$positiveDeltaColor !== 'green')
    ) {
      return Colors.GreenLightest;
    } else {
      return Colors.RedLightest;
    }
  }};
`;

export const Metric = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
`;

export const PrimaryValueStyled = styled(Text)`
  font-size: 40px;
  font-weight: 600;
`;

export const SecondaryValueStyled = styled(Text)`
  font-size: 18px;
  color: ${ct({ Dark: Colors.Dark, Light: Colors.Dark })};
`;
